import { FC } from "react";
import { Helmet } from "react-helmet";

const text = {
  pageTitle: "Plan Select",
};

export const Meta: FC = () => {
  return (
    <Helmet>
      <title itemProp="name" lang="en">
        {text.pageTitle}
      </title>
    </Helmet>
  );
};
